<template>
<div>
    <v-card outlined v-if="loaded">
        <v-simple-table>
            <template v-slot:default>
            <thead v-if="items.length > 0">
                <tr>
                <th class="text-left">Name</th>
                <th class="text-left">Email</th>
                <th class="text-left" v-if="user.role.master">Applying for</th>
                <th class="text-left">Registration</th>
                <th class="text-left">Profile</th>
                </tr>
            </thead>
            <tbody v-if="items.length > 0">
                <tr v-for="item in items" :key="item.name">
                    <td>{{ item.name }}</td>
                    <td>{{ item.email }}</td>
                    <td v-if="user.role.master">{{getCtr(item.applyingFor).name}} Center</td>
                    <td>{{ item.regDate }}</td>
                    <td>
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn color="orange" depressed dark v-on="on">
                                    Pending
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="setProfile(item.uid, 'student', item.applyingFor)">
                                    <v-list-item-title>Student</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="setProfile(item.uid, 'captain', item.applyingFor)">
                                    <v-list-item-title>Captain</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="setProfile(item.uid, 'director', item.applyingFor)" v-if="user.role.master">
                                    <v-list-item-title>Director</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="setProfile(item.uid, 'denied')">
                                    <v-list-item-title class="red--text font-weight-medium">Deny access</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
            </tbody>
            <tbody v-if="items.length == 0">
                <tr>
                    <td class="pa-8">
                        <div class="d-flex align-center">
                            <v-icon color="info" class="mr-2">fa-info-circle</v-icon>
                            <div>No users pending to authorized.</div>
                        </div>
                    </td>
                </tr>
            </tbody>
            </template>
        </v-simple-table>
    </v-card>

    <SendingLoader v-else/>
</div>
</template>

<script>
import _ from 'lodash'
import Users from '@/firebase/users'
import Centers from '@/firebase/centers'

export default {
    data: () => ({
        loaded: false,
        items: [],
        centers: []
    }),
    props: ['tab'],
    mounted() {
        this.init();
    },
    watch: {
        tab() {
            if (this.tab == 1) {
                this.init();
            }
        }
    },
    methods: {
        init() {
            this.loaded = false;
            this.items = [];
            let factor = '';
            
            if (this.user.role.master)  factor = 'master';
            if (this.user.role.director)  factor = {role:'director', center:this.user.center};

            Users.getAllByPending(factor)
                    .then(response => {
                        if (response.status == true) {
                            this.formatItems(response.query);
                            this.getCenters();
                            this.$emit('count', this.items.length)
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        formatItems(query) {
            query.forEach(dt => {
                let u = dt.data();
                u.uid = dt.id;
                u.regDate = this.formatDate(u.registration);
                this.items.push(u);
            });

            this.items = _.orderBy(this.items, [item => item.registration], 'desc');
        },
        getCenters() {
            Centers.getAll()
                    .then(response => {
                        if (response.status === true) {
                            this.centers = this.formatCenters(response.query);
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        formatCenters(query) {
            let tempo = [];

            query.forEach(dt => {
                let u = dt.data();
                u.id = dt.id;
                tempo.push(u);
            });

            return _.orderBy(tempo, 'name', 'asc');
        },
        formatDate(dt) {
            let day = new Date(dt).getDate();
		    let month = new Date(dt).getMonth() + 1;
		    let year = new Date(dt).getFullYear();
		    let hour = new Date(dt).getHours();
            let minutes = new Date(dt).getMinutes();

            if (day < 10) {
                day = '0' + day;
            }
            if (hour < 10) {
                hour = '0' + hour;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }

            return day + '/' + month + '/' + year + ' - ' + hour + ':' + minutes + ' hrs.';
        },
        setProfile(uid, status, applyingFor) {
            if (status != 'pending') {
                Users.setProfile(uid, status, applyingFor)
                    .then(response => {
                        if (response == true) {
                            this.init();
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
            }
        },
        getCtr(idCenter) {
            return this.centers.find( item => {return item.id == idCenter});
        }
    }
}
</script>